{
  "title": "如何申請建立新競賽",
  "description": "提出競賽建立申請，經平台審核核准後系統會自動建立競賽並將您設為第一位主辦方管理員。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您的申請進入平台審核流程；核准後系統會自動建立競賽，您將自動成為該競賽的第一位管理員。",
  "roleNote": "任何已登入且已驗證 Email 的使用者",
  "prerequisites": [
    "已登入且完成 Email 驗證",
    "已備妥競賽基本資訊（名稱、網址代稱、主辦單位、聯絡人）"
  ],
  "pathLabel": "申請建立競賽",
  "steps": [
    {
      "title": "1. 開啟申請表單",
      "description": "任何已登入的使用者皆可提出申請，不需要事先具備任何角色或身分。"
    },
    {
      "title": "2. 填寫競賽基本資訊",
      "description": "填寫競賽名稱、網址代稱（slug）、主辦單位、聯絡人姓名與 Email、競賽簡介、時區；預計開始／結束時間與預計參賽人數為選填。"
    },
    {
      "title": "3. 勾選競賽性質",
      "description": "勾選是否需要評審評分（預設需要）、是否為雙輪次賽制、是否會蒐集未成年學生資料，這些選項會影響後續自動建立的競賽設定。"
    },
    {
      "title": "4. 送出申請",
      "description": "送出後申請狀態為「審核中」，可在「我的申請」查看目前狀態；審核期間仍可取消申請。"
    },
    {
      "title": "5. 等待平台審核",
      "description": "平台管理員會審核申請，結果可能是「核准」「退回並要求補充」或「拒絕」；核准後系統會自動建立競賽（含基本設定與第一個輪次），您會自動成為該競賽的 competition_admin。"
    }
  ],
  "afterward": [
    "申請狀態顯示為「審核中」，可隨時查看目前進度",
    "若被核准，系統自動建立競賽並將您設為第一位主辦方管理員，不需要另外申請角色",
    "若被要求補充，可依回饋修改後重新送出；若被拒絕，可查看拒絕原因"
  ],
  "nextSteps": "申請核准並自動建立競賽後，請見平台管理主控台或「操作手冊：主辦方」完成後續的時程、組別、報名表、Rubric 等設定。",
  "faq": [
    {
      "q": "我需要先有主辦方帳號才能申請建立競賽嗎？",
      "a": "不需要。任何已登入且完成 Email 驗證的使用者都可以提出申請，不需要事先具備任何角色；申請核准後系統會自動將您設為新競賽的第一位管理員。"
    },
    {
      "q": "申請送出後還能修改或取消嗎？",
      "a": "在申請仍處於「審核中」或「已要求補充」狀態時可以取消；一旦被核准或拒絕，該筆申請本身就不能再變更。"
    },
    {
      "q": "核准後是我自己去建立競賽嗎？",
      "a": "不是。核准後競賽由系統自動建立（Automated Provisioning），包含基本設定與第一個輪次，您不需要另外執行任何建立動作，只需要以新指派的主辦方管理員身分登入即可看到這場競賽。"
    }
  ]
}
